import { SetupInstructions } from '../../interfaces/connection.interfaces'
import { ConnectionSetupInstruction } from './connection-setup-instruction'
import { CollapseSection } from '@yuno/design-system-web'
import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

type ConnectionSetupInstructionsProps = {
  setupInstructions: Array<SetupInstructions>
}

type CollapseCSSProps = {
  index: number
  setupInstructions: Array<SetupInstructions>
}

const Container = styled('div')`
  margin-top: 20px;
`

const CollapseCSS = ({ index, setupInstructions }: CollapseCSSProps) => css`
  border-radius: ${getStyle({ index, setupInstructions })};
`

const getStyle = ({ index, setupInstructions }: CollapseCSSProps) => {
  let borderRadius = '4px 4px 0px 0px'
  if (index > 0) {
    borderRadius = '0px 0px 0px 0px'
  }
  const lastInstruction = index === setupInstructions?.length - 1
  if (lastInstruction) {
    borderRadius = '0px 0px 4px 4px'
  }
  return borderRadius
}

export const ConnectionSetupInstructions = ({
  setupInstructions,
}: ConnectionSetupInstructionsProps) => {
  const [openSections, setOpenSections] = useState([])
  const { t, i18n} = useTranslation()
  const currentLanguage = i18n.language;

  const toggleOpenSections = (index) => {
    const newOpenSections = openSections?.map((_openSection) => {
      if (_openSection?.index === index) {
        return { ..._openSection, open: !_openSection?.open }
      }
      return { ..._openSection, open: false }
    })
    setOpenSections(newOpenSections)
  }

  useEffect(() => {
    if (setupInstructions?.length) {
      const _openSections = setupInstructions?.map((instruction, index) => {
        return { open: false, index }
      })
      setOpenSections(_openSections)
    }
  }, [])

  return (
    <Container>
      {setupInstructions?.map((setupInstruction, index) => {
        const titleValue = typeof setupInstruction?.title !== 'string' ? setupInstruction?.title[currentLanguage.toLocaleUpperCase()] as string : setupInstruction?.title
        return (
          <CollapseSection
            title={titleValue}
            containerStyle={CollapseCSS({ index, setupInstructions })}
            key={titleValue}
            open={openSections[index]?.open}
            onToggle={toggleOpenSections.bind(null, index)}
          >
            <ConnectionSetupInstruction
              instrunctions={setupInstruction?.instructions}
              instrunctionsType={setupInstruction?.instructions_type}
            />
          </CollapseSection>
        )
      })}
    </Container>
  )
}
